import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon37: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 18.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 18" width={width} height={height} {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.97 0C18.646 0 20 1.354 20 3.03V5.97C20 7.636 18.662 8.984 17 9V11.5C17 11.945 16.461 12.169 16.146 11.854L14 9.70799V11.97C14 13.586 12.741 14.903 11.148 14.995L10.97 15H6.70697L3.854 17.854C3.539 18.169 3 17.945 3 17.5V15C1.338 14.984 0 13.636 0 11.97V9.03C0 7.354 1.35403 6 3.03003 6L6 5.99899V3.03C6 1.354 7.35403 0 9.03003 0H16.97ZM3.03003 7C1.90603 7 1 7.906 1 9.03V11.97C1 13.094 1.90603 14 3.03003 14H3.5C3.776 14 4 14.224 4 14.5V16.293L6.146 14.146C6.24 14.053 6.367 14 6.5 14H10.97C12.094 14 13 13.094 13 11.97V9.058C13 9.041 13 9.02201 12.998 9.00101L9.03003 9C7.72503 9 6.59803 8.18 6.18103 7H3.03003ZM10.5 11C10.776 11 11 11.224 11 11.5C11 11.776 10.776 12 10.5 12H9.5C9.224 12 9 11.776 9 11.5C9 11.224 9.224 11 9.5 11H10.5ZM4.5 11C4.776 11 5 11.224 5 11.5C5 11.776 4.776 12 4.5 12H3.5C3.224 12 3 11.776 3 11.5C3 11.224 3.224 11 3.5 11H4.5ZM7.5 11C7.776 11 8 11.224 8 11.5C8 11.776 7.776 12 7.5 12H6.5C6.224 12 6 11.776 6 11.5C6 11.224 6.224 11 6.5 11H7.5ZM16.97 1H9.03003C7.90603 1 7 1.906 7 3.03V5.97C7 6.113 7.01601 6.25499 7.04901 6.39799C7.24401 7.331 8.06103 8 9.03003 8H13.5C13.633 8 13.76 8.053 13.854 8.146L16 10.293V8.5C16 8.224 16.224 8 16.5 8H16.97C18.094 8 19 7.094 19 5.97V3.03C19 1.906 18.094 1 16.97 1ZM16.5 5C16.776 5 17 5.224 17 5.5C17 5.776 16.776 6 16.5 6H15.5C15.224 6 15 5.776 15 5.5C15 5.224 15.224 5 15.5 5H16.5ZM10.5 5C10.776 5 11 5.224 11 5.5C11 5.776 10.776 6 10.5 6H9.5C9.224 6 9 5.776 9 5.5C9 5.224 9.224 5 9.5 5H10.5ZM13.5 5C13.776 5 14 5.224 14 5.5C14 5.776 13.776 6 13.5 6H12.5C12.224 6 12 5.776 12 5.5C12 5.224 12.224 5 12.5 5H13.5Z"
        fill="#4775FF"
      />
    </Icon>
  )
}
